import React, { useState, useEffect } from 'react';
import { getTermsOfService } from '../../api/authApi';
import logo from '../../assets/images/logo.png';

const TermsOfService = () => {
    const [termsData, setTermsData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchContent = async () => {
            try {
                const result = await getTermsOfService();
                setTermsData(result.data);
            } catch (err) {
                setError("Failed to load documentation.");
            } finally {
                setLoading(false);
            }
        };
        fetchContent();
    }, []);

    const formatContent = (text) => {
        if (!text) return null;
        return text.split('\n').map((line, index) => {
            const trimmedLine = line.trim();

            if (/^\d+\./.test(trimmedLine)) {
                return (
                    <h2 key={index} className="text-slate-900 font-semibold text-xl mt-10 mb-4 tracking-tight">
                        {trimmedLine}
                    </h2>
                );
            }

            if (trimmedLine.startsWith('-')) {
                return (
                    <li key={index} className="text-slate-600 ml-6 mb-2 list-none flex items-start">
                        <span className="mr-2 text-slate-400">•</span> {trimmedLine.substring(1)}
                    </li>
                );
            }

            return trimmedLine ? (
                <p key={index} className="text-slate-600 mb-4 leading-7 text-[16px]">
                    {line}
                </p>
            ) : <div key={index} className="h-2" />;
        });
    };

    if (loading) return (
        <div className="flex justify-center items-center min-h-screen bg-white">
            <div className="w-6 h-6 border-2 border-slate-200 border-t-slate-800 rounded-full animate-spin"></div>
        </div>
    );

    return (
        <div className="min-h-screen bg-white text-slate-900 selection:bg-blue-50">
            <div className="sticky top-0 z-10 bg-white/80 backdrop-blur-md border-b border-slate-100">
                <div className="max-w-3xl mx-auto px-6 py-4 flex justify-between items-center">
                    <span className="font-bold text-sm tracking-tight">
                        <img
                            className="img-thumbnail !p-0 !border-none !max-w-[160px] md:!max-w-[160px]"
                            src={logo}
                            alt="logo"
                        />
                    </span>
                    <span className="text-slate-400 text-xs font-medium uppercase tracking-widest">
                        Terms of Service
                    </span>
                </div>
            </div>

            <main className="max-w-3xl mx-auto px-6 py-16 md:py-16">
                <header className="mb-12 border-b border-slate-100 pb-12">
                    <h1 className="text-4xl font-bold text-slate-900 mb-4">
                        Terms of Service
                    </h1>
                    <p className="text-slate-500 text-sm">
                        Last Updated: {termsData?.last_updated || 'January 22, 2026'}
                    </p>
                </header>

                <article className="prose prose-slate max-w-none">
                    {formatContent(termsData?.content)}
                </article>

                <footer className="mt-20 pt-8 border-t border-slate-100 flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-slate-400 text-xs">
                        © {new Date().getFullYear()} Datara LLC. All rights reserved.
                    </p>
                    <div className="flex gap-6">
                        <button
                            onClick={() => window.print()}
                            className="text-slate-900 text-xs font-semibold hover:text-slate-600 transition-colors"
                        >
                            Print Document
                        </button>
                        <a href="mailto:support@datara.com" className="text-slate-900 text-xs font-semibold hover:text-slate-600">
                            Contact Support
                        </a>
                    </div>
                </footer>
            </main>
        </div>
    );
};

export default TermsOfService;